// Animacoes de cartas voando pra mesa.
//
// MINHA carta (Hand → mesa): Svelte crossfade pair com key matching
// exato — carta sai do slot da mao e desliza pro slot da mesa. Requer
// JS porque mede posicoes runtime.
//
// Cartas DOS OPONENTES/PARCEIRO: keyframes CSS direcionais. Cada slot
// usa uma classe (.fly-from-top/-left/-right) e a anim CSS roda. Mais
// elegante que transition fn JS — keyframes ficam no Card.svelte ou
// CSS global, GPU otimiza, devtools mostra direto.

import { crossfade } from 'svelte/transition';
import { cubicOut } from 'svelte/easing';

const [sendCard, receiveCard] = crossfade({
  duration: 500,
  easing: cubicOut,
  fallback(_node) {
    return {
      duration: 240,
      easing: cubicOut,
      css: (t) => `opacity: ${t}; transform: scale(${0.7 + 0.3 * t})`,
    };
  },
});

export { sendCard, receiveCard };
